import { noop } from 'utils'
import { useDispatch, useSelector } from 'react-redux'
import { memo, useMemo } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { DeemedPopup } from 'components/dialog/Modals'
import { Dialogs } from './dialogSlice'
import {
  getLastDialogIndex,
  useCreateDialogHook,
} from 'features/dialog/dialogHookFactory'
import NoneAnchor from 'components/NoneAnchor'

const Dialog = memo(
  ({
    id,
    style,
    type = 'basic_layer2',
    className,
    innerClassName,
    children,
    onClose = noop,
    onOpen = noop,
    changeLayoutClass = true,
  }) => {
    const dispatch = useDispatch()
    const items = useSelector(state => state.dialog.items)
    const enable = !!items[id]
    return (
      <DeemedPopup
        className={classNames(type, className)}
        on={enable}
        onOpen={onOpen}
        changeLayoutClass={changeLayoutClass}
        style={{
          position: 'relative',
          left: 'auto',
          top: 'auto',
          ...style,
        }}>
        <div className={classNames('inner_basic_layer', innerClassName)}>
          {children}
          <NoneAnchor
            className="btn_close"
            onClick={() => {
              onClose({ isConfirmed: false })
              dispatch(Dialogs.hide(id))
            }}>
            <span className="ico_comm ico_close">닫기</span>
          </NoneAnchor>
        </div>
      </DeemedPopup>
    )
  }
)

Dialog.displayName = 'Dialog'
Dialog.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  style: PropTypes.object,
  className: PropTypes.string,
  innerClassName: PropTypes.string,
  type: PropTypes.oneOf([
    'basic_layer',
    'basic_layer2',
    'basic_layer3',
    'basic_layer4',
    'basic_layer5',
  ]),
  changeLayoutClass: PropTypes.bool,
}

export default Dialog

export const useDialog = (changeLayoutClass = true) =>
  useCreateDialogHook(
    Dialog,
    useMemo(() => getLastDialogIndex(), []),
    changeLayoutClass
  )
